const pathDraw =
  "M50 87.9c1.6-24.6 1.1-38.8 5.3-42.7 \
  3.9-3.7 10.9-4.6 22.8-5.5C52 36.7 52.6 37.4 50 12c-2.6 \
  25.4-2 24.6-28.1 27.7 12 .8 18.9 1.9 22.8 5.5 4.1 3.9 \
  3.7 18.2 5.3 42.7";

export const Beacon = () => (
  <svg
    className="sg-logo"
    xmlns="http://www.w3.org/2000/svg"
    height="64px"
    width="64px"
    viewBox="0 0 100 100">
    <title>World Vision</title>
    <circle fill="#ff6b00" cx="50" cy="50" r="48" />
    <path fill="#fff" d={pathDraw} />
  </svg>
);
